import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api";
import Pagination from "../../../../components/Pagination/Pagination";

const ManageClassroom = ({ uid }) => {
  const [classrooms, setClassrooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Search Query State
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");

  // Fetch Classrooms from API
  useEffect(() => {
    const fetchClassrooms = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/api/lmsclassroom/show/${uid}`);
        const classroomData = Array.isArray(response.data) ? response.data : [response.data];
        setClassrooms(classroomData);
      } catch (error) {
        console.error("Error fetching classrooms:", error);
      } finally {
        setLoading(false);
      }
    };

    if (uid) {
      fetchClassrooms();
    }
  }, [uid]);

  // Handle Search Input Change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle Sort Change
  const handleSortChange = (e) => {
    setSortOrder(e.target.value);
  };

  // Filter Classrooms Based on Search Query
  const filteredClassrooms = classrooms
    .filter((classroom) => {
      const query = searchQuery.toLowerCase();
      return (
        classroom.branch?.toLowerCase().includes(query) ||
        classroom.room_name?.toLowerCase().includes(query) ||
        classroom.academic_year?.toLowerCase().includes(query) ||
        classroom.semester?.toString().includes(query)
      );
    })
    .sort((a, b) => {
      if (sortOrder === "newest") {
        return new Date(b.created_at) - new Date(a.created_at);
      } else {
        return new Date(a.created_at) - new Date(b.created_at);
      }
    });

  // Pagination Logic
  const totalPages = Math.ceil(filteredClassrooms.length / itemsPerPage);
  const paginatedClassrooms = filteredClassrooms.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Handle Page Change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="left-0 z-45 w-full mt-8">
      <div className="container mx-auto p-4">
        <h2 className="text-2xl sm:text-4xl font-bold mb-6 text-center">Manage Classroom</h2>

        {/* Search Bar and Sort */}
        <div className="flex flex-col sm:flex-row sm:justify-between items-center mb-6">
  {/* Search Bar */}
  <div className="relative w-full sm:w-auto flex flex-row-reverse mr-4    sm:ml-auto mb-4 sm:mb-0">
    <input
      type="text"
      placeholder="Search by Branch, Room Name, Academic Year, or Semester..."
      value={searchQuery}
      onChange={handleSearchChange}
      className="border rounded px-4 py-2 w-full sm:w-80 text-gray-700 focus:outline-none focus:border-blue-500"
    />
 
  </div>

  {/* Sort Dropdown */}
  <div className="w-full sm:w-auto mb-4 sm:mb-0">
    <select
      value={sortOrder}
      onChange={handleSortChange}
      className="border rounded px-4 py-2 w-full sm:w-auto"
    >
      <option value="newest">Sort by: Newest</option>
      <option value="oldest">Sort by: Oldest</option>
    </select>
  </div>
</div>


        {/* Table */}
        {loading ? (
          <div className="flex justify-center items-center">
            <p className="text-xl font-semibold text-gray-500">Loading...</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="table-auto min-w-full">
              <thead>
                <tr>
                  <th className="px-4 py-2 text-left">Classroom Name</th>
                  <th className="px-4 py-2 text-left">Branch</th>
                  <th className="px-4 py-2 text-left">Semester</th>
                  <th className="px-4 py-2 text-left">Created Time</th>
                  <th className="px-4 py-2 text-left">Add Students</th>
                  {/* <th className="px-4 py-2 text-left">Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {paginatedClassrooms.map((classroom) =>
                  classroom && classroom.room_name ? (
                    <tr key={classroom.classroom_id} className="border-t">
                      <td className="border px-4 py-2">{classroom.room_name}</td>
                      <td className="border px-4 py-2">{classroom.branch || "Unknown Branch"}</td>
                      <td className="border px-4 py-2">{classroom.semester}</td>
                      <td className="border px-4 py-2">
                        {new Date(classroom.created_at).toLocaleString()}
                      </td>
                      <td className="border px-4 py-2">
                        <Link
                          to={`/lms/manageclassroom/${classroom.classroom_id}`}
                          className="text-green-500 hover:underline"
                        >
                          Manage Class Students
                        </Link>
                      </td>
                      {/* <td className="border px-4 py-2">
                        <Link
                          to={`/lms/EditCohort/${classroom.classroom_id}`}
                          className="text-blue-500 hover:underline mr-4"
                        >
                          Edit
                        </Link>
                      </td> */}
                    </tr>
                  ) : null
                )}
              </tbody>
            </table>
          </div>
        )}

        {!loading && filteredClassrooms.length === 0 && (
          <div className="flex justify-center items-center">
            <p className="text-xl font-semibold text-gray-500">No classrooms found.</p>
          </div>
        )}

        {!loading && filteredClassrooms.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default ManageClassroom;
